module.exports.SIGNUP_USER_JOBS = [
  {
    job_title: 'Défenseur syndical',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Stagiaire',
    positions: [],
    firm_size: true,
    is_icp: false,
    is_pro: false,
  },
  {
    job_title: 'Élève-avocat',
    positions: [],
    firm_size: true,
    is_icp: false,
    is_pro: false,
  },
  {
    job_title: 'Avocat',
    positions: ['Associé', 'Collaborateur', 'Salarié'],
    firm_size: true,
    is_icp: true,
    is_pro: true, // user is a profesionnal, not a "consommateur" (legal)
  },
  {
    job_title: 'Étudiant',
    positions: ['Étudiant en droit', 'Autre filière'],
    firm_size: false,
    is_icp: false,
    is_pro: false,
  },
  {
    job_title: 'Juriste',
    positions: ['Directeur / Responsable juridique', 'Juriste d’entreprise', 'Stagiaire'],
    firm_size: true,
    is_icp: true,
    is_pro: true,
  },
  {
    job_title: 'Juriste (secteur public)',
    positions: ['Directeur / Responsable juridique', 'Juriste', 'Stagiaire'],
    firm_size: true,
    is_icp: true,
    is_pro: true,
  },
  {
    job_title: 'Documentaliste',
    positions: [],
    firm_size: true,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Expert immobilier',
    positions: [],
    firm_size: true,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Professeur',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Magistrat ou Juge',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Greffier',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Huissier',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Notaire',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Expert-comptable',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Membre d’une association',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: false,
  },
  {
    job_title: 'Journaliste',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Finance / Gestion / Risque / Fiscal',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: true,
  },
  {
    job_title: 'Autre',
    positions: [],
    firm_size: false,
    is_icp: false,
    is_pro: false,
  },
];

module.exports.FIRM_SIZES = ['Individuel', '2-5 personnes', '6-40 personnes', 'Plus de 40 personnes'];
module.exports.DEFAULT_FOLDER_TITLE = "À classer";
module.exports.DEFAULT_FOLDER_ANNOTATION_TEXT = `Bienvenue dans vos dossiers !

Ceux-ci vous permettent notamment de rassembler des décisions relatives :
- au même client (exemple : "Divorce Mr Dupont")
- au même thème juridique (exemple : "Données personnelles")

En plus d'organiser vos recherches, vos dossiers vous permettent d'obtenir des recommandations. Plus vous ajouterez de décisions, plus les recommandations que vous obtiendrez dans ces mêmes dossiers seront pertinentes.`;
